import Immutable from 'immutable';
import { deepMerge } from '../../../../common/immutable/merge';
import { ACTIVE_MATCH_TICKETS_LS, MATCH_TICKETS } from './constants';

export const EXPANDED_MATCH_TICKETS = ['ticketus', 'active', 'expanedMatchTickets'];

export const activeMatchTicketsInit = db =>
    db.setIn(EXPANDED_MATCH_TICKETS, Immutable.fromJS(JSON.parse(localStorage.getItem(ACTIVE_MATCH_TICKETS_LS))));

export const loadActiveTickets = json => db =>
    db.updateIn(MATCH_TICKETS, existing => deepMerge(existing, Immutable.fromJS(json.sportEventToTickets)));

export const loadActiveMatchTickets = json => db => {
    const betIdsToPickIds = json.betIdsToPickIds || {};
    const iBetIdsToPickIds = Object.keys(json.betIdsToPickIds || {}).reduce((map, betId) => {
        return map.set(betId, Immutable.Set(betIdsToPickIds[betId]));
    }, Immutable.Map());
    return db.updateIn(['ticketus', 'active', 'match', 'betIdsToPickIds'], existing =>
        deepMerge(existing, iBetIdsToPickIds)
    );
};

export const matchActiveTicketsToggle = matchId => db => {
    const old = db.getIn(EXPANDED_MATCH_TICKETS);
    if (old === matchId) {
        return db.removeIn(EXPANDED_MATCH_TICKETS);
    }
    return db.setIn(EXPANDED_MATCH_TICKETS, matchId);
};

export const changeTicketusActiveMark = db => db.setIn(['ticketus', 'active', 'mark'], new Date().getTime());
